import React from 'react';
import PropTypes from 'prop-types';
import { Stepper } from 'material-ui/Stepper';
import DropBuryStep from 'ticketComponents/DropBuryStep';
import InsideHomeAccess from 'ticketComponents/InsideHomeAccess';
import CloseCommentStep from 'commentComponents/CloseCommentStep';
import RaisedButton from 'material-ui/RaisedButton';
import CloseCodeCloseStep from 'closeCodeComponents/CloseCodeCloseStep';
import SqcCloseStep from 'equipmentComponents/SqcCloseStep';
import CloseOrderStatusStep from 'orderStatusComponents/CloseOrderStatusStep';
import PmTicketStep from 'ticketComponents/PmTicketStep';
import StepConfig from 'utils/stepConfig';
import SignalLevelsCloseStep from '../../signal-levels/SignalLevelsCloseStep';
import DeliveryProofCloseStep from '../../delivery-proof/DeliveryProofCloseStep';
import OutletOptimizationStatusStep  from '../../outlet-optimization/OutletOptimizationStatusStep';
import NoAccessReasonStep from '../../noaccess-reason/NoAccessReasonStep';
import { isFinalState } from 'utils/orderStatusUtils';
import ChargesCloseStep from 'chargeComponents/ChargesCloseStep';
import TruckRollCloseStep from 'truckRollComponents/TruckRollCloseStep';
import { isSkinnyInstallType } from '../../../utils/helper';
import { isFiberOrCommercial } from '../../../utils/accountUtils';
class CloseSteps extends React.Component {

    constructor(props) {
        super(props);
        this.addCloseRequest = this.addCloseRequest.bind(this);
        this.removeSqcInfoFromCloseRequest = this.removeSqcInfoFromCloseRequest.bind(this);
    }

    removeSqcInfoFromCloseRequest(closeOrderRequest) {
        return closeOrderRequest.setIn([
            'sqcInfoRequest', 'data'
        ], null).setIn([
            'sqcInfoRequest', 'generateSqcRequestId'
        ], 0);
    }

    addCloseRequest(e) {
        e.preventDefault();

        const { orderCloseDetails, workOrderActions, orderId, schedulingSystemDetail } = this.props;
        let closeOrderRequest = orderCloseDetails.getIn(['closeOrderRequest']);
        const serviceTypeId = schedulingSystemDetail.getIn(['serviceOrderInfoV2', 'serviceTypeId']);
        const orderStatus = orderCloseDetails.getIn(['closeOrderRequest', 'orderStatus']);

        //Do not send sqc info if order closed as NoAccess or if job type is SR
        if (serviceTypeId.startsWith('SR') || (orderStatus && orderStatus === 'NoAccess') || isSkinnyInstallType(serviceTypeId)) {
            closeOrderRequest = this.removeSqcInfoFromCloseRequest(closeOrderRequest);
        }

        workOrderActions.orderCloseRequestAddStarted(closeOrderRequest.toJS(), orderId);
    }

    render() {

        const {
            user,
            orderCloseDetails,
            sqcResults,
            workOrderActions,
            orderId,
            closeCodes,
            equipmentDetails,
            sqcActions,
            schedulingSystemDetail,
            orderStatus,
            charges,
            accountNumber,
            chargeActions,
            customerDetail,
            techId,
            packageDetails,
            equipmentDetailsComplete
        } = this.props;

        if (!orderCloseDetails) {
            return null;
        }

        const activeStep = orderCloseDetails.get('currentStep');
        const currentStatus = orderCloseDetails.getIn(['closeOrderRequest', 'orderStatus']);
        const serviceTypeId = schedulingSystemDetail.getIn(['serviceOrderInfoV2', 'serviceTypeId']);
        const billingSystem = schedulingSystemDetail.get('billingSystem');
        const isReadyToClose = orderCloseDetails.getIn(['stepValidation', 'isReadyToClose']);
        const isFiberOrCommer = customerDetail ?  isFiberOrCommercial(customerDetail.get("signalAccessCode"), customerDetail.get("customerType")) : false;
        const isCustomerDetailMissing = customerDetail == null;
        const stepConfig = new StepConfig(currentStatus, serviceTypeId, isFiberOrCommer,isCustomerDetailMissing);
        const orderToSqc = !isSkinnyInstallType(serviceTypeId);

        const statusStep = (<CloseOrderStatusStep
            key="close_status_step"
            orderId={orderId}
            serviceTypeId={serviceTypeId}
            disabled={isFinalState(orderStatus)}
            stepConfig={stepConfig}
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions}
            equipmentDetails={equipmentDetails}
            packageDetails={packageDetails}
            customerDetails={customerDetail} />);

        const commentStep = (<CloseCommentStep
            key="close_comment_step"
            orderId={orderId}
            stepConfig={stepConfig}
            disabled={isFinalState(orderStatus)}
            user={user}
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions} />);

        const sqcStep = (<SqcCloseStep
            key="sqc_close_step"
            orderId={orderId}
            stepConfig={stepConfig}
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions}
            equipmentDetails={equipmentDetails}
            sqcActions={sqcActions}
            sqcResults={sqcResults}
            orderToSqc={orderToSqc} />);

        const closeCodeStep = (<CloseCodeCloseStep
            key="close_code_step"
            stepConfig={stepConfig}
            disabled={isFinalState(orderStatus)}
            user={user}
            orderId={orderId}
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions}
            closeCodes={closeCodes}
            billingSystem={billingSystem} />);

        const fstSignalCloseStep = (<SignalLevelsCloseStep
            key="fst_signal_levels_step"
            orderId={orderId}
            techId={techId}
            serviceTypeId={serviceTypeId}
            disabled={isFinalState(orderStatus)}
            stepConfig={stepConfig}
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions} />);


        const dropBuryStep = (<DropBuryStep
            key="drop_bury_step"
            orderId={orderId}
            stepConfig={stepConfig}
            disabled={isFinalState(orderStatus)}
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions} />);

        const insideHomeAccess = (<InsideHomeAccess
            key="inside_home_step"
            orderId={orderId}
            stepConfig={stepConfig}
            disabled={isFinalState(orderStatus)}
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions} />);

        const pmTicketStep = (<PmTicketStep
            key="pm_ticket_step"
            orderId={orderId}
            disabled={isFinalState(orderStatus)}
            stepConfig={stepConfig}
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions} />);

        const chargesCloseStep = (<ChargesCloseStep
            key="charge_step"
            orderId={orderId}
            accountNumber={accountNumber}
            user={user}
            charges={charges}
            orderStatus={orderStatus}
            disabled={isFinalState(orderStatus)}
            chargeActions={chargeActions}
            index={stepConfig.chargesStepConfig.index}
            stepConfig={stepConfig}
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions}
            serviceTypeId={serviceTypeId}
            customerDetails={customerDetail}
            equipmentDetailsComplete={equipmentDetailsComplete}
        />);

        const truckRollStep = (<TruckRollCloseStep
            key="truck_roll_step"
            workOrderActions={workOrderActions}
            chargeActions={chargeActions}
            orderId={orderId}
            accountNumber={accountNumber}
            orderStatus={orderStatus}
            disabled={isFinalState(orderStatus)}
            orderCloseDetails={orderCloseDetails}
            stepConfig={stepConfig}
            user={user}
            customerDetail={customerDetail}
            billingSystem={billingSystem}/>);
        
        const deliveryProofStep = (<DeliveryProofCloseStep
            key="image_proof_step"
            customerDetail={customerDetail}
            billingSystem={billingSystem}
            equipmentDetails={equipmentDetails}
            techId={techId}
            orderId={orderId}
            stepConfig={stepConfig}
            index={stepConfig.deliveryProofStepConfig.index}
            disabled={isFinalState(orderStatus)}
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions} />);

        const noAccessReasonStep = (<NoAccessReasonStep
            key="no_access_reason_step"
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions}
            stepConfig={stepConfig}
            orderId={orderId}
            disabled={isFinalState(orderStatus)}
        />);

        const outletOptimizationStatusStep = (<OutletOptimizationStatusStep
            key="outlet_optimization_step"
            orderCloseDetails={orderCloseDetails}
            workOrderActions={workOrderActions}
            stepConfig={stepConfig}
            orderId={orderId}
            disabled={isFinalState(orderStatus)}
        />);


        const steps = [];

        let isIcoms = false;

        if (billingSystem) {
            if (billingSystem.toLowerCase() === 'icoms') {
                isIcoms = true;
            }
        }


        const possibleSteps = [
            {
                component: statusStep,
                config: stepConfig.orderStatusStepConfig
            }, {
                component: chargesCloseStep,
                config: stepConfig.chargesStepConfig
            }, {
                component: noAccessReasonStep,
                config: stepConfig.noAccessReasonStepConfig
            }, {
                component: commentStep,
                config: stepConfig.commentStepConfig
            }, {
                component: sqcStep,
                config: stepConfig.sqcStepConfig
            }, {
                component: closeCodeStep,
                config: stepConfig.closeCodeStepConfig
            }, {
                component: dropBuryStep,
                config: stepConfig.dropBuryStepConfig
            }, {
                component: insideHomeAccess,
                config: stepConfig.insideHomeAccessStepConfig
            }, {
                component: pmTicketStep,
                config: stepConfig.pmStepConfig
            },
            {
                component: truckRollStep,
                config: stepConfig.truckRollStepConfig
            },
            {
                component: outletOptimizationStatusStep,
                config: stepConfig.outletOptimizationStatusStepConfig
            },
            {
                component: fstSignalCloseStep,
                config: stepConfig.fstSignalStepConfig
            }, {
                component: deliveryProofStep,
                config: stepConfig.deliveryProofStepConfig
            }
        ];

        possibleSteps.sort((a, b) => {
            if (a.config.index < b.config.index) {
                return -1;
            }

            if (a.config.index > b.config.index) {
                return 1;
            }

            return 0;
        });

        possibleSteps.forEach((step) => {
            if (step.config.index >= 0) {
                steps.push(step.component);
            }
        });

        const submitButtonStyle = {};

        const missingCustomerDetailLogic = () => {

            return orderCloseDetails.getIn(['stepValidation', 'orderStatus','isValid']) &&
            orderCloseDetails.getIn(['stepValidation', 'comment','isValid']);
        }

        return (

            <div className="row">

                <div
                    className="col s12"
                    style={{
                        paddingLeft: '0',
                        paddingRight: '0'
                    }}>
                    <Stepper linear={true} activeStep={activeStep} orientation="vertical">
                        {steps}
                    </Stepper>
                    <div style={{
                        paddingTop: '15px'
                    }}>
                        <RaisedButton
                            onTouchTap={this.addCloseRequest}
                            primary
                            style={submitButtonStyle}
                            fullWidth
                            label="Complete Order"
                            disabled={customerDetail ? !isReadyToClose : !missingCustomerDetailLogic()} />
                    </div>
                </div>
            </div>

        );
    }

}

CloseSteps.propTypes = {
    orderStatus: PropTypes.object,
    sqcActions: PropTypes.object,
    equipmentDetails: PropTypes.object,
    user: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    sqcResults: PropTypes.object,
    workOrderActions: PropTypes.object,
    charges: PropTypes.object,
    orderId: PropTypes.string,
    closeCodes: PropTypes.object,
    schedulingSystemDetail: PropTypes.object,
    accountNumber: PropTypes.string,
    chargeActions: PropTypes.object,
    customerDetail: PropTypes.object,
    techId: PropTypes.string,
    equipmentDetailsComplete: PropTypes.object
};

export default CloseSteps;



// WEBPACK FOOTER //
// ./src/components/work-order/close/CloseSteps.js